import React from 'react'
import {
  Box,
  Button,
  FormControl,
  TextField,
  Typography,
  Grid,
} from '@mui/material'
import { inject, observer } from 'mobx-react'
import { AuthStore, RoutingStore } from '../stores'
import { useTranslation } from 'react-i18next'
import { Logo } from '../../assets/svg/logo'
import { theme } from '../config'
import { Pages, RoutingParams } from '../routes'
import { PasswordStrength } from 'components'
import { useParams } from 'react-router'

export interface IResetPasswordProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export const ResetPassword = inject('authStore', 'routingStore')(observer((props: IResetPasswordProps) => {
  const { t } = useTranslation();
  const params: RoutingParams = useParams<RoutingParams>();

  const [token,    setToken]    = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [valid,    setValid]    = React.useState<boolean>(false);
  const [passwordRepeat, setPasswordRepeat] = React.useState<string>('');
  const [instructions,   setInstructions]   = React.useState<string>('');

  React.useEffect(() => {
    if (!params) return;
    setToken(params?.token);
  }, [params]);

  const handleSubmit = async () => {
    const res = await props.authStore.requestResetPassword(token, password);
    if(res === 'success') props.routingStore.push(Pages.BankID);
    if(res !== 'success') setInstructions(res);
  }

  const getResponseTextTranslation = (instructions: string) => {
    switch (instructions) {
      case 'success':
        return t('reset_password_instructions_sent_check_your_email_inbox');
      default:
        return t('reset_password_error');
    }
  }

  return (
    <Grid
      container
      spacing        = {0}
      direction      = 'column'
      alignItems     = 'center'
      justifyContent = 'center'
      style          = {{ minHeight: '100vh' }}
    >
      <Grid item xs={12} width='360px'>
        <Box
          display        = 'flex'
          justifyContent = 'center'
          alignItems     = 'center'
          flexDirection  = 'column'
          width          = '100%'
          p              = {3}
        >
          <Box
            style          = {{ cursor: 'pointer', color: theme.palette.blue.main }}
            display        = 'flex'
            justifyContent = 'center'
            marginTop      = '2.4rem'
            width          = '10rem'
            height         = '5rem'
          >
            <Logo />
          </Box>
          <Box width='100%' margin='normal'>
          <FormControl fullWidth margin='normal'>
              <TextField
                hiddenLabel
                type        = 'password'
                placeholder = {t('password')}
                value       = {password}
                id          = 'outlined'
                variant     = 'outlined'
                onChange    = {(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <FormControl fullWidth margin='normal'>
              <TextField
                hiddenLabel
                type        = 'password'
                placeholder = {t('repeat_password')}
                value       = {passwordRepeat}
                onChange    = {(e) => setPasswordRepeat(e.target.value)}
                id          = 'outlined'
                variant     = 'outlined'
              />
            </FormControl>
          </Box>
          <PasswordStrength
            password       = {password}
            passwordRepeat = {passwordRepeat}
            onValidate     = {(v) => setValid(v)}
          />
          <Box width='100%' margin='20px 0px' textAlign='center'>
            <Button
              variant  = 'contained'
              disabled = {!valid}
              onClick  = {handleSubmit}
            >
              {t('reset_password')}
            </Button>
          </Box>
        </Box>
      </Grid>
      <Box width='100%' margin='20px 0px' textAlign='center'>
        {instructions.length > 0 && (
          <Typography
            component = 'p'
            width     = '100%'
            textAlign = {'center'}
            color     = {
              instructions === 'success'
                ? theme.palette.green.main
                : theme.palette.error.main
            }
          >
            {getResponseTextTranslation(instructions)}
          </Typography>
        )}
      </Box>
    </Grid>
  );
}));
